<app-header [dir]="dir" />
<div class="container my-4" [dir]="dir">
  <!-- Top Bar with Total and Confirm Button -->


  <div class="row g-4">
    <div class="col-md-6" *ngFor="let item of cartItems">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-md-6">
            <div class="card-body text-end">
              <h5 class="card-title mb-3">{{ item.name }}</h5>
              <p class="card-text mb-3">
                {{ item.salesPrice }}
                {{ "translations.currency" | translate }}
              </p>

              <div class="d-flex align-items-center justify-content-center mb-3">
                <span class="text-muted me-2">
                  {{ "translations.quantity" | translate }}
                </span>
                <div class="input-group" style="width: 120px">
                  <button class="btn btn-outline-secondary"
                          type="button"
                          (click)="increaseQuantity(item.inItemID)">
                    +
                  </button>
                  <input type="text"
                         class="form-control text-center"
                         [value]="item.cartQuantity"
                         readonly />
                  <button class="btn btn-outline-secondary"
                          type="button"
                          (click)="decreaseQuantity(item.inItemID)">
                    -
                  </button>
                </div>
              </div>

              <div class="d-flex gap-2 justify-content-center">
                <button class="btn text-danger border-0"
                        (click)="removeItem(item.inItemID)">
                  {{ "translations.remove" | translate }}
                </button>
                <button class="btn border-0">
                  <i class="far fa-heart"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <img [src]="apiURL + item.photoPath || 'path-to-default-image'"
                 class="img-fluid rounded-end h-100 object-fit-cover"
                 alt="{{ item.name }}" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <div class="d-flex justify-content-between align-items-center bg-dark text-white p-3 rounded-3 mb-4">
    <button class="btn btn-light" [routerLink]="['/checkout']">
      {{ "translations.checkout" | translate }}
    </button>
    <div class="d-flex gap-4">
      <div class="d-flex align-items-center">
        <span>{{ "translations.total" | translate }}</span>
        <span class="ms-2">
          {{ totalAmount | number : "1.3-3" }} &nbsp;
          {{ "translations.currency" | translate }}
        </span>
      </div>
    </div>
  </div>


</div>
<app-footer />
